export default {
  'STATUSLIST' (state) {
    return state.statusList
  },
  isCheckOutEnabled (state) {
    return state.setting.has_checkout
  },
  requireTagOnScan (state) {
    return state.setting.require_tag_on_scan
  }
}
